import { graphQLClient } from '@api/client';
import { usePatientsQuery } from '@api/GoodocAPI';
import { useTreatmentInformationContext } from '@context/TreatmentInformation';
import {
  FocusableComponentLayout,
  useFocusable
} from '@noriginmedia/norigin-spatial-navigation';
import {
  FIRST_EXISTING_USER,
  NEW_USER
} from '@pages/PatientSetting/views/PatientSelection/focuskey';
import { generateSelectPaymentPath, PATIENT, TargetPayment } from '@router/path';
import constate from 'constate';
import { RefObject, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const usePatientSelectionStore = () => {
  const navigate = useNavigate();

  const { data: patientResponse } = usePatientsQuery(graphQLClient);
  const { setSelectedPatientId, resetPatientInformation } =
    useTreatmentInformationContext();

  const { setFocus } = useFocusable();

  const setFirstItemFocus = () => {
    if (patientResponse && patientResponse.patients.length > 0) {
      setFocus(FIRST_EXISTING_USER);
    } else {
      setFocus(NEW_USER);
    }
  };

  const scrollToItem = useCallback(
    (ref: RefObject<HTMLDivElement>, { y }: FocusableComponentLayout) => {
      ref.current?.scrollTo({ top: y, behavior: 'smooth' });
    },
    []
  );

  const goAddNewUser = () => {
    resetPatientInformation();
    navigate(PATIENT.NAME);
  };

  const goNextStep = (patientId: string) => {
    setSelectedPatientId(patientId);
    navigate(generateSelectPaymentPath(TargetPayment.treatment));
  };

  return {
    patients: patientResponse?.patients,
    setFirstItemFocus,
    scrollToItem,
    goAddNewUser,
    goNextStep
  };
};

export const [PatientSelectionProvider, usePatientSelectionContext] = constate(
  usePatientSelectionStore
);
